import { isBefore, parseISO, startOfDay, subYears } from 'date-fns'

export function idadeMaiorQue(dataNascimento: LocalDate, limiteIdadeEmAnos: number) {
  return isBefore(parseISO(dataNascimento), subYears(startOfDay(new Date()), limiteIdadeEmAnos))
}
